(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("AdalongWidget", [], factory);
	else if(typeof exports === 'object')
		exports["AdalongWidget"] = factory();
	else
		root["AdalongWidget"] = factory();
})(self, () => {
return 